//CSS
import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//icons
import { faIndustry, faBullseye, faTriangleExclamation, faBrain } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProductsIntro: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Intro" />

            <SubSection isSplit={false}>
                <div className="inv-items">
                    <div className="inv-item">
                        <div className="inv-item-header">
                            <FontAwesomeIcon icon={faIndustry} size="2x" className="inv-item-icon" />
                            <h4 className="inv-item-title">The Internal Combustion Engine Industry is Stagnant and Declining</h4>
                        </div>
                        <p className="inv-item-body">
                            With Wankel in 1957 inventing the last new engine geometry.
                        </p>
                    </div>
                    <div className="inv-item">
                        <div className="inv-item-header">
                            <FontAwesomeIcon icon={faTriangleExclamation} size="2x" className="inv-item-icon" />
                            <h4 className="inv-item-title">The Industry is Focused on EVs, but EVs Have Obvious Hard Limits</h4>
                        </div>
                        <p className="inv-item-body">
                            In range, costs, charging station limits, rare earths and materials issues, fragile supply chains, reduced jobs, end of life pollution, and limits due to vehicle sizes and battery energy density.
                        </p>
                    </div>
                    <div className="inv-item">
                        <div className="inv-item-header">
                            <FontAwesomeIcon icon={faBullseye} size="2x" className="inv-item-icon" />
                            <h4 className="inv-item-title">Positive Disruption and New Engine Designs are Overdue</h4>
                        </div>
                        <p className="inv-item-body">
                            We found them - we tested them - and - we patented them
                        </p>
                    </div>
                    <div className="inv-item">
                        <div className="inv-item-header">
                            <FontAwesomeIcon icon={faBrain} size="2x" className="inv-item-icon" />
                            <h4 className="inv-item-title">Our Solutions​​</h4>
                        </div>
                        <ul>
                            <li>E-SPEC™ Software</li>
                            <li>Elf-Tech™ CAD Designs</li>
                            <li>Engine Modeling</li>
                        </ul>
                    </div>
                </div>
            </SubSection >
        </div >
    );
};

export default ProductsIntro;
